import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const SubscriptionPlansPage: React.FC = () => {
  const [loading, setLoading] = useState<string | null>(null);

  async function handlePurchase(product: string) {
    try {
      setLoading(product);
      const resp = await fetch('https://4w8x1prii2.execute-api.us-east-2.amazonaws.com/v1/purchase/stripe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product })
      });

      if (!resp.ok) throw new Error(`API error ${resp.status}`);
      const data = await resp.json();
      const checkoutUrl = data?.checkout_url || data?.checkoutUrl || data?.url;
      if (!checkoutUrl) throw new Error('No checkout_url in response');

      // Redirect to Stripe checkout
      window.location.href = checkoutUrl;
    } catch (err) {
      // TODO: show nicer UI feedback
      // eslint-disable-next-line no-console
      console.error('Purchase error', err);
      alert('Unable to start checkout. Please try again.');
      setLoading(null);
    }
  }

  return (
    <div className="subscription-page" style={{ minHeight: '100vh', background: '#fff', color: '#044080' }}>
      {/* Top header with centered logo (no hamburger/profile) */}
      <header style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px 24px', borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
        <img className="subscription-logo" src="/HomeStream.png" alt="Homestream" style={{ height: 50, objectFit: 'cover', width: '20%' }} />
      </header>

      <main style={{ maxWidth: 1100, margin: '40px auto', padding: '0 20px' }}>
        <section style={{ textAlign: 'center', marginBottom: 32 }}>
          <h2 style={{ fontSize: 36, letterSpacing: 1.5, margin: 0 }}>CHOOSE YOUR GAME PLAN</h2>
          <p style={{ color: '#4b5563', marginTop: 12 }}>Flexible options for every fan level. From single match access to full season archives across all collegiate sports.</p>
        </section>

        <section className="plans-grid">
          {/* Season Pass - Football (left) */}
          <div className="plan-card" style={{ border: '1px solid #e5e7eb', padding: 24, borderRadius: 6, background: '#fff', boxSizing: 'border-box' }}>
            <div style={{ color: '#6b7280', fontSize: 12, marginBottom: 8 }}>TEAM FOCUS</div>
            <div style={{ fontSize: 20, fontWeight: 700 }}>SEASON PASS — FOOTBALL</div>
            <div style={{ fontSize: 36, fontWeight: 900, color: '#044080', margin: '12px 0' }}>$79.99<span style={{ fontSize: 14, fontWeight: 600, color: '#6b7280' }}> /season</span></div>
            <ul style={{ paddingLeft: 18, color: '#374151', marginBottom: 18 }}>
              <li>Full Football Season Coverage</li>
              <li>Post-Game Full Replays</li>
              <li>Enhanced 1080p Quality</li>
            </ul>
              <button
                onClick={() => handlePurchase('football_pass')}
                disabled={loading === 'football_pass'}
                style={{ display: 'inline-block', padding: '12px 20px', background: '#fff', color: '#044080', border: '2px solid #044080', borderRadius: 4, cursor: loading === 'football_pass' ? 'not-allowed' : 'pointer' }}
              >
                {loading === 'football_pass' ? 'Loading…' : 'SELECT FOOTBALL'}
              </button>
          </div>

          {/* All Sports Pass - centered featured with badge */}
            {/* All Sports Pass removed for now - keep for reference
            <div className="plan-card featured center" style={{ position: 'relative', border: '2px solid #044080', padding: 28, borderRadius: 8, background: '#ffffff', boxShadow: '0 10px 30px rgba(11,36,71,0.12)', transform: 'translateY(-6px)', boxSizing: 'border-box', textAlign: 'center' }}>
              <div style={{ position: 'absolute', top: -14, left: '50%', transform: 'translateX(-50%)', background: '#ffc857', color: '#0b2447', padding: '6px 12px', borderRadius: 6, fontWeight: 800, fontSize: 12 }}>BEST VALUED</div>
              <div style={{ color: '#6b7280', fontSize: 12, marginBottom: 8 }}>ELITE ACCESS</div>
              <div style={{ fontSize: 22, fontWeight: 700 }}>ALL SPORTS PASS</div>
              <div style={{ fontSize: 44, fontWeight: 900, color: '#044080', margin: '12px 0' }}>$119.99<span style={{ fontSize: 16, fontWeight: 600, color: '#6b7280' }}> /year</span></div>
              <ul style={{ paddingLeft: 18, color: '#374151', marginBottom: 18, listStylePosition: 'inside' }}>
                <li>Every Athletic Event</li>
                <li>4K UHD Multi-Cam View</li>
                <li>Archived Classic Games</li>
                <li>Priority Support</li>
              </ul>
              <Link to="/subscription-plans/go-all-in" style={{ display: 'inline-block', padding: '14px 26px', background: '#044080', color: '#fff', borderRadius: 4, textDecoration: 'none' }}>GO ALL-IN</Link>
            </div>
            */}

          {/* Season Pass - Basketball (right) */}
          <div className="plan-card" style={{ border: '1px solid #e5e7eb', padding: 24, borderRadius: 6, background: '#fff', boxSizing: 'border-box' }}>
            <div style={{ color: '#6b7280', fontSize: 12, marginBottom: 8 }}>TEAM FOCUS</div>
            <div style={{ fontSize: 20, fontWeight: 700 }}>SEASON PASS — BASKETBALL</div>
            <div style={{ fontSize: 36, fontWeight: 900, color: '#044080', margin: '12px 0' }}>$79.99<span style={{ fontSize: 14, fontWeight: 600, color: '#6b7280' }}> /season</span></div>
            <ul style={{ paddingLeft: 18, color: '#374151', marginBottom: 18 }}>
              <li>Full Basketball Season Coverage</li>
              <li>Post-Game Full Replays</li>
              <li>Enhanced 1080p Quality</li>
            </ul>
              <button
                onClick={() => handlePurchase('basketball_pass')}
                disabled={loading === 'basketball_pass'}
                style={{ display: 'inline-block', padding: '12px 20px', background: '#fff', color: '#044080', border: '2px solid #044080', borderRadius: 4, cursor: loading === 'basketball_pass' ? 'not-allowed' : 'pointer' }}
              >
                {loading === 'basketball_pass' ? 'Loading…' : 'SELECT BASKETBALL'}
              </button>
          </div>
        </section>
      </main>
      <footer className="subscription-footer" style={{ marginTop: 40, background: '#f3f4f6', padding: '110px 20px' }}>
        <div className="subscription-footer-grid" style={{ maxWidth: 1100, margin: '0 auto', gap: 20, alignItems: 'start' }}>
          <div>
            <div style={{ color: '#374151', marginBottom: 12 }}>Questions? Call 000-800-919-1743 (free)</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <a href="#" style={{ color: '#044080', textDecoration: 'underline' }}>FAQ</a>
              <a href="#" style={{ color: '#044080', textDecoration: 'underline' }}>Cookie Preferences</a>
            </div>
          </div>

          <div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <a href="#" style={{ color: '#044080', textDecoration: 'underline' }}>Help Centre</a>
              <a href="#" style={{ color: '#044080', textDecoration: 'underline' }}>Corporate Information</a>
            </div>
          </div>

          <div>
            <a href="#" style={{ color: '#044080', textDecoration: 'underline' }}>Terms of Use</a>
          </div>

          <div>
            <a href="#" style={{ color: '#044080', textDecoration: 'underline' }}>Privacy</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SubscriptionPlansPage;
